import { Fade } from "react-awesome-reveal";
import { SECTIONS_ID } from "../../../../constants/navigation";
import {
  MAILTO_COMMERCIAL,
  MAILTO_PEC,
  TEL_DAVIDE,
  TEL_IVANO,
  TEL_SEGRETERIA,
} from "../../../../constants/contacts";
import ContactsCardsCard, {
  ContactsCardsCardElementT,
} from "./components/contacts-cards-card";

import "./contacts-cards.scss";

const handleMapScroll = () => {
  const el = document.getElementById(SECTIONS_ID.contacts.map);
  if (el) {
    const y = el.getBoundingClientRect().top + window.scrollY - 30;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};

const card_srl_elements: ContactsCardsCardElementT[] = [
  {
    title: "Indirizzo",
    text: "Via Vittorio Emanuele II n.41/1, 35026 Conselve PD",
    icon: "location",
    iconType: "secondary",
    onClick: handleMapScroll,
  },
  {
    title: "P.IVA",
    text: "04903730283",
    icon: "id-cardsvg",
    iconType: "secondary",
  },
  {
    title: "Email",
    text: "commerciale@rotoinfissioni.it",
    icon: "envelope",
    iconType: "primary",
    href: MAILTO_COMMERCIAL,
  },
  {
    title: "PEC",
    text: "rotoinfissionisrl@pec.it",
    icon: "shield",
    iconType: "secondary",
    href: MAILTO_PEC,
  },
];

const card_phone_elements: ContactsCardsCardElementT[] = [
  {
    title: "Segreteria",
    text: "335.6996848",
    icon: "mobile",
    iconType: "primary",
    href: TEL_SEGRETERIA,
  },
  {
    title: "Davide Violato",
    text: "340.4147436",
    icon: "mobile",
    iconType: "secondary",
    href: TEL_DAVIDE,
  },
  {
    title: "Ivano Violato",
    text: "335.5932676",
    icon: "mobile",
    iconType: "primary",
    href: TEL_IVANO,
  },
];

const ContactsCards = () => {
  return (
    <section className="contacts-cards">
      <div className="contacts-cards__card">
        <Fade
          direction="left"
          duration={900}
          triggerOnce
          style={{ height: "100%" }}
        >
          <ContactsCardsCard
            title={"Rotoinfissioni S.R.L"}
            iconTitle={"building"}
            iconTitleType={"primary"}
            elementList={card_srl_elements}
          />
        </Fade>
      </div>

      <div className="contacts-cards__card">
        <Fade
          direction="right"
          duration={900}
          delay={150}
          triggerOnce
          style={{ height: "100%" }}
        >
          <ContactsCardsCard
            title={"Contatti Telefonici"}
            iconTitle={"phone"}
            iconTitleType={"secondary"}
            elementList={card_phone_elements}
          />
        </Fade>
      </div>
    </section>
  );
};

export default ContactsCards;
